module.exports = __webpack_public_path__ + "img/c6.44596e2b.png";